import { openItemPeekInternal } from './openItemPeekInternal';
import { openItemPeek } from '../actions/itemPeekActions';
import { lazyTryFetchRelatedContentInsights } from 'owa-calendar-related-content';
import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';
import { orchestrator } from 'satcheljs';

orchestrator(openItemPeek, actionMessage => {
    let { item } = actionMessage;
    openItemPeekInternal(item);

    // Try fetching event related content when user opens the item peek
    lazyTryFetchRelatedContentInsights.importAndExecute(
        item.ItemId.Id,
        InsightsDataFetchSource.ItemPeek
    );
});
